<template>
  <div><v-container>No dashboard yet.</v-container></div>
</template>

<script>
export default {};
</script>

<style></style>
